import { createSlice } from '@reduxjs/toolkit';
import { CREATE_ACTIVITY_PRICING_STEP_KEYS, STEP_CLEANUP_CONFIG } from './createActivityAndPricingConsts';

const createInitialState = () => ({
    currentStep: 0,
    isEditMode: false,
    editActivityId: null,
    originalSteps: null,
    steps: {
        [CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS]: {
            activityTypeId : null,
            name: null,
            paramTypes: [],
            materials : [],
            noCharge: false,
            takePhotos: false,
            defaultStatus: null,
            readonly: false,
            typeTag: null,
            pricingType: 1
        },
        [CREATE_ACTIVITY_PRICING_STEP_KEYS.PRICING]: {
            pricingItems: [],
            editingPricingKeys: [],
            somePricingHasUnsavedEdits: false
        },
        [CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES]: {
            rulesList: [],
            editingRuleKeys: [],
            someRuleHasUnsavedEdits: false
        }
    }
});

const initialState = createInitialState();

export const createActivityAndPricingStateSlice = createSlice({
    name: 'createActivityAndPricingState',
    initialState,
    reducers: {
        setCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        saveStepData: (state, action) => {
            const { stepKey, data } = action.payload;
            if (!stepKey) {
                return;
            }

            state.steps[stepKey] = {
                ...state.steps[stepKey],
                ...data
            };
        },
        cleanupStepDraft: (state, action) => {
            const { stepKey } = action.payload;
            const stepData = state.steps[stepKey];

            if (!stepData) return;

            const config = STEP_CLEANUP_CONFIG[stepKey];
            if (!config) return;

            const { listKey, editingKey, unsavedFlag } = config;

            stepData[listKey] = (stepData[listKey] || []).filter(item => !item.isNew);
            stepData[editingKey] = [];
            stepData[unsavedFlag] = false;
        },
        initializeForEdit: (state, action) => {
            const { activityDetails, pricingItems, rulesList, editActivityId } = action.payload;
            state.isEditMode = true;
            state.editActivityId = editActivityId;
            state.currentStep = 0;

            const activityDetailsData = {
                ...createInitialState().steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS],
                ...activityDetails
            };
            const pricingData = {
    ...createInitialState().steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.PRICING],
    pricingItems: pricingItems || []
};
         
            const rulesData = {
                ...createInitialState().steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES],
    rulesList: rulesList || [],
            };

            state.steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS] = activityDetailsData;
            state.steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.PRICING] = pricingData;
            state.steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES] = rulesData;

            state.originalSteps = {
                [CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS]: structuredClone(activityDetailsData),
                [CREATE_ACTIVITY_PRICING_STEP_KEYS.PRICING]: { pricingItems: structuredClone(pricingItems || []) },
                [CREATE_ACTIVITY_PRICING_STEP_KEYS.RULES]: { rulesList: structuredClone(rulesList || []) }
            };
        },
        resetCreateActivityAndPricingState: () => createInitialState()
    }
});

export const {
    setCurrentStep,
    saveStepData,
    cleanupStepDraft,
    initializeForEdit,
    resetCreateActivityAndPricingState
} = createActivityAndPricingStateSlice.actions;

export default createActivityAndPricingStateSlice.reducer;